import { ErrorBase } from '@/errors/ErrorBase';

export class DisabledCustomerError extends ErrorBase {
    static get defaultMessage(): string {
        return 'ご利用のクラウドIDは有効ではないため、ログインすることができません。';
    }

    static get errorName(): string {
        return 'DisabledCustomerError';
    }
}
